<script>
    import { onMount } from "svelte";
    import Router, { route, resolveExportUrl } from "../router.js";
    import { AuthUser, PageUrl } from "../store.js";
    import wrappedFetch from "../wrappedFetch.js";
    import Message from "./components/message.svelte";
    import Card from "./components/card.svelte";
    import { loop_guard } from "svelte/internal";
    
    let pageTitle = "Home | Wavenet Nimbus";
    let accessDenied = false;
    
    let appsactive = [];
    let apps = [];
    $: {
        if ($AuthUser != null) {
            getApps();
        }
    }
    onMount(async () => {

        

        if ($AuthUser != null) {
            getApps();
        }
        else {
            accessDenied = true;
            pageTitle = "Access Denied | Wavenet Nimbus";
        }

    });

    const getApps = async () => {
        let resp = await wrappedFetch("/api/apps/getapps", { method: "get" });
        let apps = await resp.json();
        
        appsactive = apps.filter((app) => app.isInstalled === true);

        //let resp = await wrappedFetch("/api/apps/getapps")
        //.then(response => response.json())
        //.then(response =>{ apps = response});
    };

    function getLinks(url) {
        Router.route(url);
        return false;
    }
</script>

<style>
    .img-responsive {
        width: 100%;
        height: auto;
    }
</style>

<svelte:head>
    <title>{pageTitle}</title>
</svelte:head>

{#if (!accessDenied)}

<!-- {#if $AuthUser.hasMultiSync}
<h1>MultiSync Setup</h1>
    <div class="row">
        <div class="apps-container  col-12">
            <div class="row mt-3">            
                    <div class="col-12">
                        <Message message="Please go to Settings -> Permissions to add any user from the Head Office to become a Nimbus Admin then proceed to setup Google and/or Microsoft MultiSync under the MultiSync section."></Message>
                    </div>
              
            </div>
        </div>
    </div>
{:else} -->

<h1>My Apps</h1>
    <div class="row">
        <div class="apps-container  col-12">
            <div class="row mt-3">
                {#if appsactive.length > 0}
                    {#each appsactive as app}
                        <div
                            class="col-sm-6 col-md-4 col-lg-3 text-center d-flex mb-4">
                            <Card>
                                <div slot="body">
                                    <a href="{app.configUrl}" on:click="{() => getLinks(app.configUrl)}" target="_self">
                                        <img src={app.imageUrl} alt={app.name} class="img-responsive" />
                                    </a>
                                </div>
                                <div slot="footer">
                                    <a href="{app.configUrl}" on:click="{() => getLinks(app.configUrl)}" class="btn btn-primary" target="_self">Configure</a>
                                </div>
                            </Card>
                        </div>
                    {/each}
                {:else}
                    <div class="col-12">
                        <Message message="There are no apps currently installed. Apps can be installed on the <a href='/app/discover'>Discover</a> page."></Message>
                    </div>
                {/if}                
            </div>
        </div>
    </div>
<!-- {/if} -->
{:else}
    <div class="d-flex justify-content-center">
        <div class="card col-md-6 col-sm-12" style="margin-top: 60px;">
            <div class="card-body text-center">
                <span class="material-icons" style="font-size: 120px;">lock</span>
                <h2 style="/* margin-bottom: 30px; */">Access denied</h2>
                <p style="margin-bottom: 5px;">You don't have permissions to access this website.</p>
                <p>Please get in contact with us to request access.</p> 
                <p style="margin-bottom: 0px;"><a href="https://www.wavenet.co.uk/contact-us" target="_blank" class="btn btn-primary">Contact Us</a></p>
            </div>
        </div>
    </div>
{/if}